export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_04e1c747-9bcd-4ef3-b529-605a9e6e033e/artifacts/yxjeg0h3_image.png",
  heroLogo: "/cascante-logo.png",
  rider: "/rider.png",
  gallery: [
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/h8kgdcwg_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/33l5wyf7_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/bnsfnmqx_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/74g96qix_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/8pa6w0qn_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/vqx5bmma_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/qhpb22m4_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/chh0gbyp_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/v4fol1mf_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/rt0kbch4_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/97npnl3k_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/5lff939x_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/u71sbj1l_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/7wajdh5v_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/vv5zvies_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/13j07rz9_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/njch5i0x_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/lgjbh33k_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/i7smnqsj_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/ysjll9g6_image.png",
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/vdk5vp1r_image.png",
  ],
  motoPrimary:
    "https://static.prod-images.emergentagent.com/jobs/04e1c747-9bcd-4ef3-b529-605a9e6e033e/images/ac985b0a2e66614259a524a02e9eec33b14cf9ca9d5b837ba0b4ba2d99924234.png",
  bgBeach:
    "https://static.prod-images.emergentagent.com/jobs/04e1c747-9bcd-4ef3-b529-605a9e6e033e/images/005fc67b5990b7965dace659421f33d832f369455957aab3cd9b51d90f72a44f.png",
  lifestyle1:
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/bnsfnmqx_image.png",
  lifestyle2:
    "https://customer-assets.emergentagent.com/job_cascante-moto/artifacts/h8kgdcwg_image.png",
};

export const CONTACT = {
  whatsapp: "50581017026",
  whatsappDisplay: "+505 8101 7026",
  email: "Cascantemotorental@gmail.com",
  instagram: "https://www.instagram.com/cascante_moto_rental",
  facebook: "https://www.facebook.com/Cascantemotorentals",
  googleMaps: "https://www.google.com/maps?q=San+Juan+del+Sur,+Rivas,+Nicaragua",
  city: "San Juan del Sur, Rivas, Nicaragua",
};

export const whatsappLink = (msg) =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(
    msg || "Hola Cascante Moto Rental, me interesa rentar una moto."
  )}`;

export const LANGUAGES = [
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
];

export const TESTIMONIALS = [
  {
    name: "Jason T.",
    rating: 5,
    text:
      "Cascante Motorcycle Rental — fantastic business run by Luis. Everything is 'yes, no problem at all'. Super rates and always great maintenance, really good motorbikes with surf racks if required. Best moto hire I've been to, period. Right in the centre of SJDS.",
    date: "Feb 2025",
  },
  {
    name: "James C.",
    rating: 5,
    text:
      "Possibly the best moto rental company in the whole of Central America!! My girlfriend and I rented a DR200 and a Navi for nearly a month. Bikes were clean cosmetically and mechanically and a bunch of fun. Super fair price, amazingly friendly. Gracias y nos vemos pronto 🙌🏼⚡️",
    date: "Jan 2026",
  },
  {
    name: "Julian P.",
    rating: 5,
    text:
      "Luis is the man and his team is excellent! The motorbike I rented from Cascante for 3 months has never given me any problems. Whenever it needs attention or a tune-up they are quick to make it happen. I'd recommend renting from Cascante to anyone in San Juan. Thank you guys.",
    date: "Feb 2026",
  },
  {
    name: "Edward K.",
    rating: 5,
    text:
      "Best motorbike rental in SJDS! We just turned up and Luis sorted us right out with some pukka motorbikes. Did us a cheeky price for 10 days rental too! Highly recommend.",
    date: "Apr 2025",
  },
  {
    name: "Joseph C.",
    rating: 5,
    text:
      "Excellent service. Very accommodating with delivery and the motorbike was in perfect condition. Luis was very responsive if you had questions as well! Would definitely rent again.",
    date: "Feb 2025",
  },
  {
    name: "Brandon P.",
    rating: 5,
    text:
      "Rented two Honda Navis for 2 months, never had any problems with the motorbikes, prices were very fair and the rental shop was always quick to respond and help with any questions. I will continue to come back each time I return. Highly recommend.",
    date: "Mar 2026",
  },
  {
    name: "Rasti",
    rating: 5,
    text:
      "The best rental company in town. Honest, easy, good prices. I had a motorbike for just $40 for 2 days and have seen all the beaches from Popoyo to the Costa Rica border.",
    date: "Jan 2025",
  },
  {
    name: "Quentin C.",
    rating: 5,
    text:
      "Super good rental. These guys are real pearls — happy to help, convenient and open-minded. The motorbike quality and price are really good and the location in the middle of the city is perfect in case there's any flat tire or trouble. Would definitely go again!",
    date: "Jan 2025",
  },
  {
    name: "Omosefe O.",
    rating: 5,
    text:
      "The best ATV experience I have ever had! Touring San Juan del Sur with a quad was the best decision and made our time there so much more fun. Staff were super kind, patient and very helpful! Would 10000% recommend.",
    date: "Jan 2025",
  },
  {
    name: "Yoann D.",
    rating: 5,
    text:
      "We rented 3 motorcycles with friends — the experience was absolutely amazing. Flexible, fast and always with a smile. Bikes in excellent condition, full tank, good brakes, solid tires. We came back at 6:40pm past closing and they kindly waited for us. 100% recommend!",
    date: "Aug 2025",
  },
  {
    name: "Steve M.",
    rating: 5,
    text:
      "The owner and his staff are true gentlemen. I rented a 2025 Honda scooter — very reliable, was able to visit beautiful beaches difficult to reach but the scooter handled them no problem. Always polite, professional and patient. Highly recommend.",
    date: "Sep 2025",
  },
  {
    name: "Frusso",
    rating: 5,
    text:
      "Highly recommend!! We were looking for a motorbike for the day but wanted to drop it off after 5pm to catch sunset and they were extremely flexible — none of the other rentals could offer this. Bike was in great condition and we test-rode it beforehand. :)",
    date: "Nov 2025",
  },
];
